<div class="dialog-panel">
  @if (loading) {
    <div class="spinner-container p-absolute">
      <mat-spinner class="primary" [diameter]="30"></mat-spinner>
    </div>
  }
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <iframe id="preview-iframe"></iframe>
</div>
